<template>
	<div>
		<div>
			<h3>{{ title }}</h3>
			<p>時間：{{ time }}</p>
			<p>發佈人員：{{ name }}</p>
		</div>
		<hr />
		<div class="content">
		{{content}}
		</div>
		<div>
			<div class="img" v-for="(item, index) in img" :key="index">
				<el-image :src="item" :preview-src-list="img" />
			</div>
		</div>
		<el-button class="btn" @click="$router.back(-1)">返 回</el-button>
	</div>
</template>

<script>
export default {
	data() {
		return {
			title: '標題',
			time: '時間',
			name: '人員',
			content: '內容',
			img:[]
		}
	},
	mounted() {
		$('#pageHead').text('通知詳情');
	},
	created() {
		let id = this.$route.params.id;
		if(id){
			this.axios.get("/manage/getTerMessage?id="+id).then(res=>{
				if (res) {
					let result = res.result;
					this.title=result.title;
					this.time=result.creationTime;
					this.name=result.name;
					this.content=result.content;
					this.img = result.image.split(',');
					}
			})
		} else {
			this.$router.go(-1)
		}
	}
}

</script>

<style scoped>
p {
	color: #999;
}
div{
	text-align: center;
}
hr {
	border-bottom: none;
	border-top: 3px solid #999;
}
.btn {
	position: absolute;
	top: 90px;
	right: 45px;
}
h4 {
	text-align: left;
	margin-left: 20%;
}
.content {
	padding: 12px;
	text-align: left;
	text-indent: 4em;
}
.img {
	margin-top: 12px;
}
/deep/ img {
	height: 200px;
}
</style>
